// lib/constants/app-constants.ts
// Application constants used throughout the system

export const ORDER_INCREMENT = 1000;
export const DRAG_Z_INDEX = 1000;
export const DAY_IN_MS = 24 * 60 * 60 * 1000;
export const SIDEBAR_MIN_WIDTH = 240;
export const SIDEBAR_MAX_WIDTH = 500;
export const SIDEBAR_DEFAULT_WIDTH = 320;
export const DRAG_ACTIVATION_DISTANCE = 5;

// Time-related constants for UI operations
export const STATUS_DISPLAY_SHORT = 3;
export const STATUS_DISPLAY_LONG = 5;
export const PAGE_RELOAD_DELAY = 1;

// Progress-related constants
export const PROGRESS_MAX = 100;
export const PROGRESS_STEP = 25;
export const PROGRESS_INTERVALS = [0, 25, 50, 75, 100];

// Input and form constants
export const PRICE_STEP = 1;
export const DECIMAL_STEP = "any";
export const QUANTITY_STEP = 1;
export const DEFAULT_MIN_VALUE = 0;
export const MODAL_MAX_HEIGHT = '90vh';
export const MODAL_MAX_WIDTH = '4xl';

// Date and time constants
export const YEAR_MIN = 2000;
export const YEAR_MAX = 2050;

// Date format system - DD-MM-YYYY
export const DATE_FORMAT_DISPLAY = 'dd-MM-yyyy';
export const DATE_FORMAT_INPUT = 'yyyy-MM-dd';
export const DATE_FORMAT_LONG = 'dd MMMM yyyy';
export const DATE_FORMAT_SHORT = 'dd/MM/yy';
export const DATE_FORMAT_MONTH_YEAR = 'MMMM yyyy';

// Z-Index Layer System - Systematic approach to prevent conflicts
// Based on SHADCN_ZINDEX.md documentation standards
export const Z_INDEX_LAYERS = {
  BASE: 0,              // Base content, sections, background
  SUBTABS: 100,         // Tabs at parent sections
  MODALS: 200,          // First level modals (includes fields and tabs within modals)
  INNER_FIELDS: 300,    // Reserved for special cases above modals but below submodals
  SUB_MODALS: 400,      // Independent submodals (mounted as separate Dialogs via Portal)
  SUPRA_FIELDS: 500,    // Internal naming for overlay fields
  DROPDOWNS: 500,       // Dropdowns, popovers, calendars, over-field UI
  TOOLTIPS: 600,        // Tooltips and small overlays
  NOTIFICATIONS: 800,   // Notifications and alerts
  CRITICAL: 1000,       // Highest priority modals (delete confirmations, critical alerts)
  DRAG: 1500,           // For dragging elements
  MAX: 9999,            // Emergency upper bound
} as const;

// UI and interaction constants
export const MIN_WIDTH_150 = 150;
export const TRANSITION_DURATION_150 = 150;
export const TRANSITION_DURATION_15 = 15;
